
export const firebaseConfig = {
  apiKey: "AIzaSyA1opvs6GrzT-bT_KRvyZ6kSqEUr_fS9Ko",
  authDomain: "audio-cardio-166e2.firebaseapp.com",
  databaseURL: "https://audio-cardio-166e2.firebaseio.com",
  projectId: "audio-cardio-166e2",
  storageBucket: "audio-cardio-166e2.appspot.com",
  messagingSenderId: "889922806452",
  appId: "1:889922806452:web:0631458043fc54ba992de1",
  measurementId: "G-2K825NP3W5",
};
export const stripeConfig = {
  publicKey: "pk_live_q3RKLQme8qZw7FSjO8SPQIa400d8VuzhRd",
};
export const baseUrl = "https://audio-cardio-166e2.appspot.com/api/v1/stripe";
export const appURL = "https://audio-cardio-166e2.appspot.com/api/v1";
export const adminBaseUrl = "https://audio-cardio-166e2.appspot.com/api/v1/users";
export const appURLV2 = "https://audio-cardio-166e2.appspot.com/api/v2";

